import { jsx as _jsx } from "react/jsx-runtime";
import PageHeaderActions from "./components/PageHeaderActions";
import PageHeaderTitle from "./components/PageHeaderTitle";
const PageHeader = ({ children }) => {
    return _jsx("div", { className: "flex w-full justify-between gap-5 border-gray-light border-b pb-2.5", children: children });
};
PageHeader.Title = PageHeaderTitle;
PageHeader.Actions = PageHeaderActions;
export default PageHeader;
